import { render, staticRenderFns } from "./cache.vue?vue&type=template&id=7215de16&"
import script from "./cache.vue?vue&type=script&lang=js&"
export * from "./cache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports